const tabNav = document.querySelectorAll('.tab-nav button');
const tabs = document.querySelectorAll('.tab-grid');

tabNav.forEach((button, index) => {
  button.addEventListener('click', () => {
    tabNav.forEach((button, buttonIndex) => {
      button.classList.remove('tw-border-b');
      if(buttonIndex === index) {
        button.classList.add('tw-border-b');
      }
    });
    tabs.forEach((tab, tabIndex) => {
      tab.classList.add('tw-hidden');
      if(tabIndex === index) {
        tab.classList.remove('tw-hidden');
      }
    });
  });
});

// Equal height cards
window.addEventListener("load", function(){
  equalheight('.product-card-wrapper .card');
});

window.addEventListener("resize", function(){
  setTimeout(function(){
    equalheight('.product-card-wrapper .card');
  });
});
